export const func = {
    exceptionsHandler: (error) => {
        let response = error.response;
        let status = typeof response != "undefined" && response.status ? response.status : 0;
        let message = 'Не можем обработать ошибку';
        if(typeof response != "undefined"){
            if(typeof response.data != "undefined"){
                if(typeof response.data.message != "undefined"){
                    message = response.data.message;
                }
            } else if(typeof response.statusText != "undefined"){
                message = response.statusText;
            }
        }
        switch (status){
            case 400:
                window.$func.getAlert('error', 'Ошибка', 'Не верный запрос')
                window.getAlert('error', 'Ошибка', 'Не верный запрос')
                break;
            case 403:
                window.$func.getAlert('error', 'Ошибка', 'Нет доступа')
                window.getAlert('error', 'Ошибка', 'Нет доступа аккаунта')
                break;
            case 413:
                window.$func.getAlert('error', 'Ошибка', 'Слишком долгая загрузка файла, проверьте интернет и размер файла')
                window.getAlert('error', 'Ошибка', 'Слишком долгая загрузка файла, проверьте интернет и размер файла')
                break;
            case 419:
                window.$func.getAlert('error', 'Ошибка', 'Запрещен доступ, либо истек срок авторизации')
                window.getAlert('error', 'Ошибка', 'Запрещен доступ, либо истек срок авторизации')
                break;
            default:
                console.log(message);
                window.$func.getAlert('error', 'Ошибка ' + status, message);
                window.getAlert('error', 'Ошибка ' + status, message);
                break;
        }
    },
    getAlert: function (type, label, message){
        let ev = new CustomEvent("modal-show", {
            detail: {
                open: true,
                type: type,
                label: label,
                message: message,
            },
            bubbles: true,
            cancelable: false,
            composed: true,
        });
        document.dispatchEvent(ev);
    }
}